import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import {
  FormFields,
  type FormValues,
  type TierRule as TierRuleType,
} from '../../hooks/useBadgeForm/types'
import { RuleLayout } from '../RuleLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
  tiers: SelectOption[]
  rule: TierRuleType
}

export const TierRule = ({ form, options, tiers, rule }: Props) => (
  <RuleLayout
    top={
      <Select
        value={'Tier' satisfies TierRuleType['type']}
        label="Requirement to earn badge"
        options={options}
        onValueChange={(value) => {
          const newRules = form.values.rules.map((formRule) =>
            formRule === rule ? { type: value } : formRule,
          )

          form.setFieldValue(FormFields.rules, newRules)
        }}
      />
    }
    bottom={
      <Select
        label="Tier"
        options={tiers}
        value={rule.tierId?.toString()}
        onValueChange={(value) => {
          const newRules = form.values.rules.map((formRule) =>
            formRule === rule
              ? {
                  type: 'Tier',
                  tierId: parseInt(value),
                }
              : formRule,
          )

          form.setFieldValue(FormFields.rules, newRules)
        }}
      />
    }
    onRemove={() => {
      form.setFieldValue(
        FormFields.rules,
        form.values.rules.filter((formRule) => formRule !== rule),
      )
    }}
  />
)
